import { useSelector } from "react-redux";

const useSubscription = () => {
	const auth = useSelector((state: any) => state.auth);
	return auth?.company?.subscription || auth?.subscription;
};

export default useSubscription;
